import * as Sentry from '@sentry/react'
import { Route } from 'react-router'

export default Sentry.withSentryRouting(Route)
